import { Image } from "react-native";
import React from "react";

interface ImageMenuProps {
  uri?: string;
  source?: string;
  mr?: number;
}

const ImageMenu = ({ uri, mr, source }: ImageMenuProps) => {
  return (
    <Image
      style={{
        width: 28,
        height: 28,
        marginRight: mr ?? 0,
        // marginRight: 10,
        // backgroundColor: Colors.primaryColor,
      }}
      source={
        source
          ? source
          : {
              uri: uri,
            }
      }
    />
  );
};

export default ImageMenu;
